<template>
   <Modal :id="'cmp-settings-money-details-form'" @cancelled="onCancel">
      <template slot="header"> {{$t('category_type')}}</template>
      <template slot="body">
         <div class="form-group">
            <TextField
               class="m1"
               :id="'category_name'"
               v-bind="textFieldConfig"
               required
               :showValidationIcons="true"
               :immediateValidation="true"
               :value="CategoryName
               "
               :placeholder="$t('name')"
               @valuechanged="onTextFieldValueChange"
               @validated="(e, vr) => onValidationDone('product_type_name', vr)"
               ></TextField>
            <DTable2
            :boxheader="boxheader"
            :items="SubCategories"
            :headers="[]"
            :itemName="$t('sub_category')"
            :primaryKey="'category_id'"
            :labelKey="''"
            :fieldKey="'category_name'"
            :fieldPlaceholder="'Custome Field Name'"
            @add_click="onSubCategoryAddClick"
            @changed="onSubCategoryChange"
            @selected="onSubCategorySelect"
            @deleted="onSubCategoryDelete"
            />
         </div>
      </template>
      <template slot="options">
         <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
         <button 
            @click.stop="onFormSubmit"
            class="dt-button v1 s6"
     
            >{{$t('ok')}}</button>
      </template>
   </Modal>
</template>
<script>
   import Modal from "@dtplugins/modal/modal";
   import { createFormModalMixin, createFormItemMixin } from "../../../../dt-plugins/form-modal/form-modal";
   import { PromotionSettingsService } from "../../services/promotion-settings.service";
   import { getVatTypes } from "../../models/invoice-line.model";
   import { createTextFieldConfig } from '../../../../plugins/text-field';
   import DList from "@dtplugins/list/dlist";
   import DBox from "@dtplugins/dbox/dbox";
   import DTable2 from "@dtplugins/dtable/dtable-2";
   import { random, generateNextId, isNegative } from '../../../../utility/fp';
import { Action } from 'rxjs/internal/scheduler/Action';
import * as ActionTypes from "../../store/types";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { promotionSettingsActions } from '../../store/promotion/actions';
import { PromotionSettingsData } from '../../store/types';

   export default {
     components: {
       Modal,
       DBox,
       DList,
       DTable2,
     },
     props: {},
     mixins: [],
     data: function() {
       return {
         
         vatT_types: getVatTypes(),
   
         textFieldConfig: createTextFieldConfig({
           height: 42,
           showEditIconOnHover: false,
           box: true,
           showValidationIcons: false,
         }),
   
         formValidation: {},
   
         category_name:"",
         CategoryId:"",
         CategoryName:"",
         SubCategories:[],
         SubCategoryStrings:"",
         boxheader:"SubCategories"
       };
     },
     methods: {
       fetchData:async function()
       {
          
          if(this.$route.query.mode=="edit")
          {
            const subCatResponse=await PromotionSettingsService.getCategoryDetails(this.$route.query.catId)
     
             this.SubCategories=subCatResponse.data.categories
             this.CategoryName=this.$route.query.catValue
             this.CategoryId=this.$route.query.catId
          }
         //let catId=this.$route.catId
       },
       ...mapActionObject(storeNS, promotionSettingsActions),
       onSubCategoryAddClick:function(){
           this.SubCategories= [
           {
             category_id: generateNextId( this.SubCategories.map(e => +e.category_id)),
             category_name: '',
           },
            ...this.SubCategories,
         ]
       },
       onSubCategoryChange:function(item){
        console.log("SUB_CAT",item)
        const {category_id}=item.item
        
        if (isNegative(category_id)) {
            this.SubCategories= this.SubCategories.map(m => {
              if (m.category_id == category_id) {
                  return {
                     ...m,
                     category_id: category_id,
                     category_name: item.value,
                   };
                 } else {
                   return m;
                 }
   
                });
           } else {
             
             const updatedSubcategory= PromotionSettingsService.updateSubCategories(category_id,item.value)
              this.SubCategories=  this.SubCategories.map(m => {
                 if (m.category_id == category_id) {
                   return {
                     ...m,
                     category_name: item.value,
                   };
                 } else {
                   return m;
                 }
               })
          
           
          }

          
       },
       onSubCategorySelect:function(){
   
       },
       onSubCategoryDelete:async function(item){
           await PromotionSettingsService.deleteCategory(item.category_id)
           this.SubCategories =this.SubCategories.filter(m => {
        return m.category_id != item.category_id
      })
       },
       get_category: function() {
         return {
           categories:[]
         };
       },
       onCheckboxChange: function(name, event) {
         const value = event.target.checked ? '2' : '1';
         this.product_type[name] = value;
       },
       onValidationDone: function(id, validationResult) {
         this.formValidation = {
           ...this.formValidation,
           [id]: validationResult
         };
       },
       isFormValid: function() {
         return Object.keys(this.formValidation).map(key => this.formValidation[key].valid).every(e => e);
       },
       onCancel:function()
       {
         this.$emit("cancelled", true);
       },
       onTextFieldValueChange:function(name, value){
         
          this.CategoryName=value
       },
       onFormSubmit:async function()
       {
        
          this.SubCategoryStrings=this.SubCategories.map(s=>{
            if(isNegative(s.category_id) && (s.category_name!="" && s.category_name!=null))
            {
              return s.category_name
            }
          }).join(',')
          
          let payload={CategoryId:this.CategoryId,CategoryName:this.CategoryName,SubCategoryStrings:this.SubCategoryStrings}
          console.log("SubCategories",this.SubCategories)
          console.log("SubCategoryStrings",this.SubCategoryStrings)
          console.log("Payload",payload)
          if(this.$route.query.mode=="add")
          {
            await this[ActionTypes.Category.INSERT.SINGLE](payload)
          }
          else
          {
            await this[ActionTypes.Category.UPDATE.SINGLE](payload)
          }
          
          this.$emit("cancelled", true);
        
       }
       //MARK: Methods
     },
     mounted:function () {
    
      this.fetchData()
     }
   };
</script>
<style lang="scss">
   .cmp-settings-money-details-form {
   .dt-checkbox-control {
   display: flex;
   padding-top: 12px;
   // margin-left: 0px;
   .dt-checkbox {
   max-width: 40px;
   margin: 3px 10px 0px 0px;
   }
   }
   .dt-ntable{
     --ntable-height: 300px;
   }
   }
</style>